export default "__VITE_ASSET__D44tyVKv__"